import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ImpersonationService } from 'src/app/core/auth/impersonation.service';
import { IMPERSONATION_CONSTS } from 'src/app/core/auth/impersonation.const';

@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  private readonly impersonationService = inject(ImpersonationService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Get impersonation token if active
    const impersonationToken = this.impersonationService.getImpersonationToken();

    // If impersonating, use impersonation token instead of admin token
    if (impersonationToken) {
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${impersonationToken}`,
        },
      });

      return next.handle(cloned).pipe(
        tap((event: HttpEvent<unknown>) => {
          // Check for impersonation headers in response
          if (event instanceof HttpResponse) {
            const impersonationActive = event.headers?.get('X-Impersonation-Active');

            if (impersonationActive === 'true') {
              // Impersonation is working correctly
              // console.log('Impersonation active:', event.headers.get('X-Impersonation-ID'));
            }
          }
        }),
        catchError((error: HttpErrorResponse) => {
          // Handle impersonation-specific errors
          if (error.status === 401 && error.error?.code) {
            const errorCode = error.error.code;

            if (errorCode === IMPERSONATION_CONSTS.ERROR_CODES.TOKEN_EXPIRED) {
              this.impersonationService.handleTokenExpiration();
            } else if (errorCode === IMPERSONATION_CONSTS.ERROR_CODES.TOKEN_REVOKED) {
              this.impersonationService.handleTokenRevocation();
            }
          }

          return throwError(() => error);
        })
      );
    }

    // No impersonation, continue with regular flow
    return next.handle(req);
  }
}
